import * as Yup from 'yup';
import getMaximumDecimalSchema from './getMaximumDecimalSchema';

export default function getNonZeroNumberSchema(
  customMessage: string,
  maxDecimalPlaces: number = 2
) {
  return Yup.number()
    .concat(getMaximumDecimalSchema(maxDecimalPlaces))
    .typeError("Please enter a valid number")
    .required(`${customMessage} is required.`)
    .notOneOf([0], `${customMessage} cannot be $0.`);
}
